var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.272 1.24062C12.8052 0.763253 12.1714 0.495117 11.5104 0.495117C10.8494 0.495117 10.2156 0.763264 9.74861 1.24062L0.508391 10.6941C0.444507 10.7564 0.403408 10.839 0.391741 10.9282L0.0027362 14.3319C-0.0112344 14.4516 0.0287788 14.5713 0.111653 14.6572C0.18544 14.734 0.286352 14.7769 0.391745 14.7764H0.434472L3.80235 14.4194V14.4193C3.89025 14.4075 3.97204 14.3672 4.03565 14.3043L13.272 4.85859C13.7423 4.37874 14.0064 3.72803 14.0064 3.0495C14.0064 2.37112 13.7423 1.72041 13.272 1.24056V1.24062ZM3.58078 13.6379L0.835206 13.9354L1.15409 11.1585L8.54321 3.62092L10.9699 6.10438L3.58078 13.6379ZM11.5105 5.52902L9.08383 3.04556L10.2972 1.80388H10.2971C10.6178 1.47347 11.0546 1.28752 11.5105 1.28752C11.9662 1.28752 12.4031 1.47348 12.7239 1.80388C13.0454 2.13388 13.2259 2.58038 13.2259 3.04556C13.2259 3.51089 13.0454 3.95737 12.7239 4.28738L11.5105 5.52902Z",
    fill: "#007FA8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilIcon);
export default __webpack_public_path__ + "static/media/pencil-icon.d393fbdbb572249e0bcec6ca27a9e565.svg";
export { ForwardRef as ReactComponent };